import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=3f55e434&scoped=true"
import script from "./STable.vue?vue&type=script&lang=js"
export * from "./STable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f55e434",
  null
  
)

export default component.exports